import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';

const useHandleClickOutside = ({ ref, onClickOutside }) => {
  useEffect(() => {
    const handleClickOutside = event => {
      const callback = () => {
        if (typeof onClickOutside === 'function') {
          onClickOutside();
        }
      };

      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    window.addEventListener('mousedown', handleClickOutside);
    return () => window.removeEventListener('mousedown', handleClickOutside);
  }, [ref]);
};

const ClickOutside = ({ onClickOutside, children, closeOnHoverLeave }) => {
  const overlayElementRef = useRef(null);
  useHandleClickOutside({ ref: overlayElementRef, onClickOutside });

  const handleMouseLeave = () => {
    if (!closeOnHoverLeave) {
      return;
    }
    if (typeof onClickOutside === 'function') {
      onClickOutside();
    }
  };

  return (
    <div
      ref={overlayElementRef}
      className="outside-click-overlay-container"
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </div>
  );
};

export default ClickOutside;
